import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import CreditReportPageUI from './CreditReportPageUI.js'

class CreditReportPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      account: null,
      userId: '',
      userList: [],
      CCRResponse: null,
      downloadMode: false,
      download2Mode: false
    }
  }

  render() {
    return (
      <CreditReportPageUI
        context={this.props.context}
        account={this.state.account}
        onRefreshClick={this.onRefreshClick}
        //
        userId={this.state.userId}
        userList={this.state.userList}
        onUserChange={this.onUserChange}
        //
        CCRResponse={this.state.CCRResponse}
        //
        onCreditReportDownloadClick={this.onCreditReportDownloadClick}
        downloadMode={this.state.downloadMode}
        selectedUserId={this.state.selectedUserId}
        //
        download2Mode={this.state.download2Mode}
        onCommercialCreditReportDownloadClick={this.onCommercialCreditReportDownloadClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccounts(context)
    this.getAccountUsers(context)
  }

  getAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Accounts(this.props.match.params.accountId),
      callback: this.getAccountsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getAccountsCallback = (response) => {
    this.setState({ account: response.account })
  }

  getAccountUsers(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/users?withPanOnly=true`,
      cacheKey: CacheKeys.AccountUsers(this.props.match.params.accountId),
      callback: this.getAccountUsersCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountUsersCallback = (response) => {
    let userList = response.accountUserList.map(user => {
      return { value: user.userId, label: user.name }
    })
    this.setState({ userList: userList })
  }

  onUserChange = (option) => {
    let context = this.props.context
    this.setState({ userId: option.value })
    this.getCreditReport(context, option.value)
  }

  getCreditReport(context, userId) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/user/${userId}/individual/creditReport`,
      cacheKey: CacheKeys.CreditReport(this.props.match.params.accountId, userId),
      callback: this.getCreditReportCallback,
      ttlInSecs: 0
    })
    cacheManager.getObject2(context)
  }

  getCreditReportCallback = (response) => {
    this.setState({ CCRResponse: response.CCRResponse })
  }

  onCreditReportDownloadClick = (event) => {
    let userId = event.currentTarget.getAttribute('data-row-id')
    this.setState({ downloadMode: true, selectedUserId: userId })

    RestApiUtils.get(this.props.context,
      `/api/su/accounts/${this.props.match.params.accountId}/user/${userId}/individual/creditReport/pdf`,
      this.onCreditReportDownloadClickCallback, null, null
    )
  }

  onCreditReportDownloadClickCallback = (response) => {
    this.setState({ downloadMode: false, errorList: response.errorList })
    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  onCommercialCreditReportDownloadClick = () => {
    this.setState({ download2Mode: true })
    RestApiUtils.get(this.props.context,
      `/api/su/accounts/${this.props.match.params.accountId}/commercial/creditReport/pdf`,
      this.onCommercialCreditReportDownloadClickCallback, null, null
    )
  }

  onCommercialCreditReportDownloadClickCallback = (response) => {
    this.setState({ download2Mode: false, errorList: response.errorList })
    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  onRefreshClick = (noBusy) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Accounts(this.props.match.params.accountId))
    CacheManager.removeObject(CacheKeys.AccountUsers(this.props.match.params.accountId))
    CacheManager.removeObject(CacheKeys.CreditReport(this.props.match.params.accountId, this.state.userId))
    if (noBusy === 'noBusy') {
      this.getAccounts(context)
      this.getAccountUsers(context)
      this.getCreditReport(context, this.state.userId)
    }
    else
      this.setState({ account: null, CCRResponse: null }, () => {
        this.getAccounts(context)
        this.getAccountUsers(context)
        this.getCreditReport(context, this.state.userId)
      })
  }
}

export default withRouter(CreditReportPageSF)
